import { CfProbeResponse } from './api/CfProbeResponse';

/**
 * The flow row, not this probe's `result`, decides: a flow past its opening
 * state is never rewritten by a later probe (`ProbeDomainUseCase.persist`), so
 * the probe's `resumeScreen` can disagree with its `result` in both directions.
 */
export const isTerminallyBlocked = (
  probe: Pick<CfProbeResponse, 'result' | 'resumeScreen'> | null,
): boolean => probe?.resumeScreen === 'blocked' || (probe?.result === 'blocked' && probe.resumeScreen === null);
